'use client';

import { useSyncExternalStore } from 'react';
import {
  getCartFlightState,
  getServerCartFlightState,
  subscribeCartFlights,
  type CartFlightState,
} from '@/lib/cart-flight';

/**
 * The add-to-cart flight store (src/lib/cart-flight.ts) as React state.
 *
 * The store changes only when a flight launches or lands, or the gate flips,
 * never per animation frame (the layer reads the store directly inside its own
 * loop), so every subscriber re-renders a couple of times per add at most. The
 * server snapshot has no flights and no hold, so the markup a cart control
 * hydrates with is the markup it had before this existed.
 */
export function useCartFlightState(): CartFlightState {
  return useSyncExternalStore(subscribeCartFlights, getCartFlightState, getServerCartFlightState);
}
